<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Dedication"></h1>
<p class="sectiontop" style="text-align:center;"><i>For Fiona</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM3_Dedication.vue?2ebc5b0e